import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import ImagePreviewLoop from "../../common/imagepreviewloop";
import { useSelector } from "react-redux";
import Formatdate from "../../common/Formatdate";
import formatDateAndTime from "../../common/formatDateAndTime";

const Paymentdetails = ({
  workOrderDetail,
  setPaymentDetails,
  paymentDetails,
  getPaymentDetails,
  getWorkOrderDetails,
  billingDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const isSystemUserList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );
  let token = localStorage.getItem("token");
  const textfields = [
    {
      type: "select",
      label: "Payment Type",
      subCategory: [
        { label: "Partial", value: "partial" },
        { label: "Full", value: "full" },
      ],
      apiKey: "paymentType",
    },
    {
      type: "number",
      label: "Payment Amount",
      apiKey: "paymentAmount",
    },
    {
      type: "select",
      label: "Payment Mode",
      subCategory: [
        { label: "Cash", value: "cash" },
        { label: "Card", value: "card" },
        { label: "UPI", value: "upi" },
      ],
      apiKey: "paymentMode",
    },
    {
      type: "text",
      label: "Transaction Id",
      apiKey: "transactionId",
    },
    {
      type: "date",
      label: "Payment Date",
      apiKey: "paymentDate",
    },
    {
      type: "file",
      label: "Attachments",
      apiKey: "attachment",
    },
  ];
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);
  const [formData, setFormData] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const handleChange = (e, field) => {
    const { value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [field.apiKey]: field.type === "file" ? Array.from(files) : value,
    }));
  };

  const handleFileChange = async (files, field) => {
    toast.loading("Image Upload Processing... Please wait", {
          id: "upload", // same ID to update later
          position: "bottom-center",
        });
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded || [];
    toast.dismiss("upload")
    setFormData((prev) => ({
      ...prev,
      [field.apiKey]: [...(prev[field] || []), ...uploaded],
    }));
  };

  const validateTransactionDetails = (formData) => {
    let errors = {};

    if (!formData?.paymentType) {
      errors.paymentType = "Payment type is required";
    }

    if (!formData?.paymentAmount || Number(formData.paymentAmount) <= 0) {
      errors.paymentAmount = "Valid payment amount is required";
    }

    if (!formData?.paymentMode) {
      errors.paymentMode = "Payment mode is required";
    }

    if (!formData?.transactionId) {
      errors.transactionId = "Transaction ID is required";
    } else if (formData.transactionId.length < 5) {
      errors.transactionId = "Transaction ID must be at least 5 characters";
    }

    if (!formData?.paymentDate) {
      errors.paymentDate = "Payment date is required";
    }

    if (!formData?.attachment || formData.attachment.length === 0) {
      errors.attachment = "At least one attachment is required";
    }

    return errors;
  };

  const handleaddTransactionDetails = async () => {
    const errors = validateTransactionDetails(formData);

    // If errors exist, show first error and stop
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((err) => toast.error(err));
      return;
    }

    toast.loading("Payment Details adding... Please wait", {
      id: "paymentdetails", // same ID to update later
      position: "bottom-center",
    });

    let payload = {
      serviceLogId: workOrderDetail?.id,
      vehicleId: workOrderDetail?.vehicleId,
      paymentAmount: Number(formData?.paymentAmount),
      paymentMode: formData?.paymentMode,
      transactionId: formData?.transactionId,
      dateOfPayment: formData?.paymentDate,
      attachments: JSON.stringify(formData?.attachment),
      paymentType: formData?.paymentType,
    };

    try {
      const response = await fetch(
        `${apiUrl}/api/servicelogpaymenttransactions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.dismiss("paymentdetails");
        toast.success("Payment Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue",
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setFormData({});
        // Only call vehicleservices API if payment type is "full"
        if (formData?.paymentType === "full") {
          await handleIsPanyemntPending();
        } else {
          await getPaymentDetails(workOrderDetail?.id);
          await getWorkOrderDetails(workOrderDetail?.id);
        }
      } else {
        toast.error(data?.msg || "Something went wrong");
      }

      return data;
    } catch (error) {
      console.error("Error fetching POST vehicle details:", error);
      toast.error("Network error, please try again");
    }
  };

  const handleIsPanyemntPending = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicleservices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          isPaymentPending: false,
          id: workOrderDetail?.id,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        await getPaymentDetails(workOrderDetail?.id);
        await getWorkOrderDetails(workOrderDetail?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  // const getPaymentDetails = async (id) => {
  //   if (!token) {
  //     return toast.error("Session Expired Close all the tab and signin again");
  //   }
  //   try {
  //     const response = await fetch(
  //       `${apiUrl}/api/servicelogpaymenttransactions?serviceLogId=${id}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //           Authorization: `${token}`,
  //         },
  //       },
  //     );
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       setPaymentDetails(data?.entities?.rows[0]);
  //     } else {
  //       toast.error(data?.msg);
  //     }
  //     return data;
  //   } catch (error) {
  //     return console.error("Error fetching Hub Names:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (workOrderDetail?.id) {
  //     getPaymentDetails(workOrderDetail?.id);
  //   }
  // }, [workOrderDetail]);

  const getImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item?.url || item?.fileUrl || item?.path || null;
  };

  const handleImageOpen = (img, idx = 0, imagesArray = []) => {
    setImageSelection(getImageUrl(img));
    setCurrentIndex(idx);
    setCurrentImages(imagesArray);
    setOpenImage(true);
  };

  return (
    <>
      {openImage && (
        <ImagePreviewLoop
          imageSelection={imageSelection}
          openImage={openImage}
          setImageSelection={setImageSelection}
          setOpenImage={setOpenImage}
          setCurrentIndex={setCurrentIndex}
          setCurrentImages={setCurrentImages}
          currentIndex={currentIndex}
          currentImages={currentImages}
        />
      )}
      <div className="p-6 bg-gray-50 min-h-screen">
        <>
          <div className="flex justify-between">
            <h2 className="text-xl font-semibold mb-6">Payment Details</h2>
            <h2 className="text-xl font-semibold mb-6 bg-red-100 text-red-700 px-4 py-2 rounded-lg">
              Outstanding Balance : ₹
              {(
                Number(billingDetails?.costToCompany || 0) -
                paymentDetails?.reduce(
                  (sum, item) => sum + Number(item?.paymentAmount || 0),
                  0,
                )
              ).toFixed(2)}
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Payment Amount
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Payment Mode
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Payment Type
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Transaction Id
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Payment Date
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Attachments
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Created By
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b">
                    Created At
                  </th>
                </tr>
              </thead>

              <tbody>
                {paymentDetails?.length > 0 ? (
                  paymentDetails.map((payment, paymentIndex) => {
                    let attachments = [];

                    try {
                      attachments = payment?.attachments
                        ? JSON.parse(payment.attachments)
                        : [];
                    } catch (error) {
                      attachments = [];
                    }

                    return (
                      <tr
                        key={paymentIndex}
                        className="hover:bg-gray-50 border-b"
                      >
                        <td className="px-4 py-4 text-sm">
                          {payment?.paymentAmount || "-"}
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {payment?.paymentMode || "-"}
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {payment?.paymentType || "-"}
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {payment?.transactionId || "-"}
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {Formatdate(payment?.dateOfPayment) || "-"}
                        </td>

                        <td className="px-4 py-4">
                          <div className="flex flex-wrap gap-3">
                            {attachments?.length > 0 ? (
                              attachments.map((file, index) => {
                                const url =
                                  file?.url ||
                                  file?.Location ||
                                  file?.path ||
                                  file?.image ||
                                  "";

                                const extension = url
                                  ?.split(".")
                                  ?.pop()
                                  ?.toLowerCase();

                                const isImage = [
                                  "jpg",
                                  "jpeg",
                                  "png",
                                  "gif",
                                  "webp",
                                ].includes(extension);

                                const isVideo = ["mp4", "webm", "ogg"].includes(
                                  extension,
                                );

                                const isPDF = extension === "pdf";

                                return (
                                  <div key={index} className="w-20 h-20">
                                    {/* IMAGE */}
                                    {isImage && (
                                      <img
                                        src={url}
                                        alt={`Attachment ${index + 1}`}
                                        className="w-full h-full object-cover rounded-lg cursor-pointer border"
                                        onClick={() => {
                                          handleImageOpen(
                                            url,
                                            index,
                                            attachments,
                                          );
                                        }}
                                      />
                                    )}

                                    {/* VIDEO */}
                                    {isVideo && (
                                      <video
                                        src={url}
                                        controls
                                        className="w-full h-full rounded-lg border"
                                      />
                                    )}

                                    {/* PDF */}
                                    {isPDF && (
                                      <div
                                        className="w-full h-full flex items-center justify-center border rounded-lg cursor-pointer bg-gray-100 p-2 text-center"
                                        onClick={() => {
                                          handleImageOpen(
                                            url,
                                            index,
                                            attachments,
                                          );
                                        }}
                                      >
                                        <span className="text-xs text-red-600 font-semibold">
                                          View PDF
                                        </span>
                                      </div>
                                    )}

                                    {/* OTHER FILES */}
                                    {!isImage && !isVideo && !isPDF && (
                                      <div
                                        className="w-full h-full flex items-center justify-center border rounded-lg cursor-pointer bg-gray-100 p-2 text-center"
                                        onClick={() => {
                                          handleImageOpen(
                                            url,
                                            index,
                                            attachments,
                                          );
                                        }}
                                      >
                                        <span className="text-xs text-blue-600 font-semibold">
                                          Open File
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <span className="text-sm text-gray-400">
                                No Attachments
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {
                            isSystemUserList.find(
                              (user) => user?.id === payment?.createdBy,
                            )?.name
                          }
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {formatDateAndTime(payment?.createdAt) || "-"}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-6 text-gray-500">
                      No Payment Details Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-6">
          <div className="mt-4">
            <div className="bg-orange-50 border-l-4 border-orange-400 p-4 rounded-lg">
              <p className="text-sm text-orange-700">
                <span className="font-bold">Note:</span>
                If the payment is being started with a partial payment, the
                final amount must be submitted by selecting the payment type as{" "}
                <span className="font-semibold">Full Payment</span>. Only then
                will the payment status be marked as{" "}
                <span className="font-semibold text-green-600">
                  Payment Confirmed
                </span>
                .
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              {textfields.map((field, index) => (
                <div key={index} className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-gray-600">
                    {field.label}
                  </label>

                  {field.type === "number" && (
                    <input
                      type="number"
                      value={formData[field.apiKey] || ""}
                      onChange={(e) => handleChange(e, field)}
                      className="border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  )}

                  {field.type === "select" && (
                    <select
                      value={formData[field.apiKey] || ""}
                      onChange={(e) => handleChange(e, field)}
                      className="border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                      <option value="">Select</option>
                      {field.subCategory?.map((option, idx) => (
                        <option key={idx} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  )}

                  {field.type === "text" && (
                    <input
                      type="text"
                      value={formData[field.apiKey] || ""}
                      onChange={(e) => handleChange(e, field)}
                      className="border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  )}

                  {field.type === "date" && (
                    <input
                      type="date"
                      value={formData[field.apiKey] || ""}
                      onChange={(e) => handleChange(e, field)}
                      className="border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  )}

                  {field.type === "file" && (
                    <input
                      type="file"
                      multiple
                      onChange={(e) => handleFileChange(e.target.files, field)}
                      className="border rounded-xl px-3 py-2 file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 hover:file:bg-blue-100"
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="mt-6">
              <button
                onClick={() => {
                  handleaddTransactionDetails();
                }}
                className="bg-blue-500 text-white px-6 py-2 rounded-xl hover:bg-blue-600 transition"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Paymentdetails;
